import React, { useState, useRef, useEffect } from "react"
import PropTypes from "prop-types"
import { linkPropTypes } from "@/utils/types"
import CustomLink from "./custom-link"
import { FiArrowRight } from "react-icons/fi"
import addToMailchimp from "gatsby-plugin-mailchimp"
import Modal from "./modal/modal"
import SubscribeModal from "./modal/subscribe-modal"
import axios from "axios"

import Logo from "../../images/logo-black.svg"
import LinkedIn from "../../images/social/linkedin.svg"
import Facebook from "../../images/social/facebook.svg"
import Instagram from "../../images/social/instagram.svg"
import Youtube from "../../images/social/youtube.svg"
import Email from "../../images/email.svg"
import LocationPin from "../../images/location-pin.svg"
import CookieModal from "./modal/cookie-modal"

const Footer = ({ footer }) => {
	const [email, setEmail] = useState("")
	const [error, setError] = useState("")
	const [submit, setSubmit] = useState(false)
	const [hostname, setHostname] = useState('')

	const formRef = useRef()
	const subscribeModalRef = useRef()
	const cookieModalRef = useRef()

	const errMessage = "Oops! Something went wrong"

	const windowCheck = () => {
		return typeof window !== `undefined` ? true : false
	}

	const initializeHubspotForm = () => {
		if ('hbspt' in window) {
			window.hbspt.forms.create({
				region: "eu1",
				portalId: "25395670",
				formId: "c33f5762-e2a5-4403-be4d-f2e8e1b35bc8",
				target: "#footer_subscribe"
			});
		} else {
			setTimeout(this.initializeHubspotForm, 500);
		}
	}

	useEffect(() => {
		if (windowCheck()) {
			initializeHubspotForm();

			setHostname(location.hostname);
		}
	}, [])

	return (
		<footer className="footer">
			<div className="footer__container">
				<nav className="footer__wrapper">
					<div className="footer__wrapper__details">
						{footer.columns.map(footerColumn => (
							<div
								key={footerColumn.id}
								className="footer__wrapper__details__column"
							>
								<div className="footer__wrapper__details__column__inner">
									<p className="footer__wrapper__details__column__title">
										{footerColumn.title}
									</p>
									<ul>
										{footerColumn.links.map(link => (
											<li
												key={link.id}
												className="footer__wrapper__details__column__item"
											>
												<CustomLink link={link}>{link.text}</CustomLink>
											</li>
										))}
									</ul>
								</div>
							</div>
						))}

						<div className="footer__wrapper__details__column">
							<p className="footer__wrapper__details__column__title">
								Contact Details
							</p>
							{

								(hostname === 'localhost' ||
									hostname === 'hooligan.co.za') &&
								<ul>
									<li>
										<div className="footer__wrapper__details__column__element">
											<div className="footer__wrapper__details__column__icon">
												<Email className="inline-block" />
											</div>
											<div className="footer__wrapper__details__column__text email">
												<a href={`mailto:${footer.email}`} aria-label={`Email ${footer.email}`} >{footer.email}</a>
											</div>
										</div>
									</li>
									<li>
										<div className="footer__wrapper__details__column__element xs:self-center">
											<div className="footer__wrapper__details__column__icon">
												<LocationPin className="inline-block" />
											</div>
											<div className="footer__wrapper__details__column__item footer__wrapper__details__column__text">
												32 Ebbehout Street,<br></br>
												Sharonlea, Randburg,<br></br>
												Johannesburg,<br></br>
												South Africa
											</div>
										</div>
									</li>
								</ul>
							}
							{
								hostname === 'hooligandevelopment.nl' && <ul>
									<li>
										<div className="footer__wrapper__details__column__element">
											<div className="footer__wrapper__details__column__icon">
												<Email className="inline-block" />
											</div>
											<div className="footer__wrapper__details__column__text email">
												<a href={`mailto:micheal@hooligandevelopment.com`} aria-label={`Email micheal@hooligandevelopment.com`} >micheal@hooligandevelopment.com</a>
											</div>
										</div>
									</li>
									<li>
										<div className="footer__wrapper__details__column__element xs:self-center">
											<div className="footer__wrapper__details__column__icon">
												<LocationPin className="inline-block" />
											</div>
											<div className="footer__wrapper__details__column__item footer__wrapper__details__column__text">
												de Akker 47,<br></br>
												Lopik 3411ZH,<br></br>
												Utrecht,<br></br>
												Netherlands

											</div>
										</div>
									</li>
								</ul>
							}
							{
								(hostname === 'hooligandevelopment.co.uk' || hostname === 'hooligandevelopment.eu') && <ul>
									<li>
										<div className="footer__wrapper__details__column__element">
											<div className="footer__wrapper__details__column__icon">
												<Email className="inline-block" />
											</div>
											<div className="footer__wrapper__details__column__text email">
												<a href={`mailto:travis@hooligandevelopment.com`} aria-label={`Email travis@hooligandevelopment.com`} >travis@hooligandevelopment.com</a>
											</div>
										</div>
									</li>
									<li>
										<div className="footer__wrapper__details__column__element xs:self-center">
											<div className="footer__wrapper__details__column__icon">
												<LocationPin className="inline-block" />
											</div>
											<div className="footer__wrapper__details__column__item footer__wrapper__details__column__text">

												3rd Floor,<br></br>
												86-90 Paul St,<br></br>
												London,<br></br>
												EC2A 4NE
											</div>
										</div>
									</li>
								</ul>
							}
						</div>
					</div>
					<div className="footer__wrapper__subscribe">
						<h5 className="footer__wrapper__subscribe__heading">Subscribe</h5>
						<div id="footer_subscribe" className="formComponent footer__wrapper__subscribe__block">

						</div>
						<p>
							Hello, we are Hooligan Development. Our goal is to translate the
							positive effects from revolutionising how companies engage with
							their clients & their team.
						</p>
					</div>
				</nav>

			</div>
			<div className="container px-12 md:px-12 sm:px-2 xs:px-2 mx-auto flex">
				<hr></hr>
			</div>
			<div className="container px-12 md:px-12 sm:px-2 xs:px-2 pb-12 mx-auto flex flex-col justify-between lg:flex-row w-full md:grid-cols-3 md:grid-rows-none sm:grid-cols-1 sm:grid-rows-3 xs:grid-cols-1 xs:grid-rows-3 gap-x-12 md:gap-x-6 justify-items-center sm:justify-between xs:justify-center">
				<div className="self-auto md:self-center xs:self-center pb-0 lg:pb-0 md:pb-8 xs:pb-8">
					<Logo className="h-[53px]" />
				</div>
				<div className="flex flex-row items-center self-auto md:self-center xs:self-center pb-0 lg:pb-0 md:pb-8 xs:pb-8">
					{footer.policies.map(link => {
						return link.text.toLowerCase() === "cookies" ? (
							<button
								aria-label={link.text}
								key={link.id}
								className="py-1 xl:px-8 lg:px-4 md:px-8 xs:px-[12px] -mx-1 list-none cursor-pointer"
								onClick={() => {
									cookieModalRef.current.openModal()
								}}
							>
								{link.text}
							</button>
						) : (
							link.pdf && (
								<a
									aria-label={link.text}
									href={link.pdf.url}
									key={link.id}
									className="py-1 xl:px-8 lg:px-4 md:px-8 px-8 xs:px-[12px] -mx-1 list-none"
									target={link.newTab ? "_blank" : ""}
									rel="noreferrer"
								>
									{link.text}
								</a>
							)
						)
					})}
				</div>
				<div className="footer__social">
					<a
						href="https://www.linkedin.com/company/hooligan-development/?viewAsMember=true"
						rel="noreferrer"
						target="_blank"
						aria-label="LinkedIn Share"
					>
						<LinkedIn className="footer__social-icon" />
					</a>
					<a
						href="https://www.facebook.com/HooliganDevelopment"
						rel="noreferrer"
						target="_blank"
						aria-label="Facebook Share"
					>
						<Facebook className="footer__social-icon" />
					</a>
					{/* <a
                        href="https://www.instagram.com/hooligan.development/"
                        rel="noreferrer"
                        target="_blank"
                        aria-label="Instagram Share"
                    >
                        <Instagram className="footer__social-icon" />
                    </a> */}
					<a
						href="https://www.youtube.com/c/HooliganCoZa"
						target="_blank"
						rel="noreferrer"
						aria-label="Youtube Share"
					>
						<Youtube className="footer__social-icon" />
					</a>
					<a href="https://techbehemoths.com/company/hooligan-development"
						target="_blank"
						rel="noreferrer"
						aria-label="Techbehemoths Share">
						<div data-tb-embedded-award data-tb-embedded-award-style="banner" data-tb-embedded-award-id="hooligan-development" data-tb-embedded-award-edition="2023">
							<svg xmlns="http://www.w3.org/2000/svg" width="164.08" height="54.18" viewBox="0 0 164.08 54.18">
								<g id="TB-trusted-on-transparent-light-bg" transform="translate(-725 -1106)">
									<g id="Logo" transform="translate(410 1059)">
										<path id="Path_1464" data-name="Path 1464" d="M4.98-9.615H8.715V-10.5H.36v.885H4.08V0h.9ZM12.045-7.5A2.274,2.274,0,0,0,10.02-6.315L9.885-7.5h-.7V0h.855V-4.26c0-1.5.675-2.415,1.995-2.415h.93V-7.5Zm7.74,0v4.11c0,1.575-.81,2.715-2.325,2.715-1.245,0-2.145-.795-2.145-2.49V-7.5h-.87V-3c0,1.92,1.1,3.15,2.88,3.15A2.609,2.609,0,0,0,19.8-1.26L19.935,0h.7V-7.5Zm2.7,5.355C22.53-.75,23.625.15,25.59.15c1.695,0,2.985-.825,2.985-2.25,0-1.185-.675-1.785-2.01-1.98l-1.59-.24c-1.02-.135-1.455-.51-1.455-1.23,0-.87.81-1.365,1.965-1.365,1.185,0,2.04.54,2.07,1.56h.87c-.03-1.5-1.26-2.295-2.955-2.295-1.605,0-2.79.825-2.79,2.1,0,1.185.72,1.8,2.13,2.01l1.605.24c.9.12,1.29.51,1.29,1.275,0,.915-.84,1.44-2.145,1.44s-2.13-.57-2.175-1.56ZM32.505,0h.945V-.8h-.825a.851.851,0,0,1-.945-.975V-6.72h1.785V-7.5H31.68V-9.42h-.855v1.29c0,.435-.165.63-.645.63H29.4v.78h1.425v5A1.543,1.543,0,0,0,32.505,0ZM41.97-3.975A3.426,3.426,0,0,0,38.415-7.65a3.553,3.553,0,0,0-3.63,3.885A3.559,3.559,0,0,0,38.445.12a3.4,3.4,0,0,0,3.42-2.43H40.98A2.591,2.591,0,0,1,38.445-.63a2.664,2.664,0,0,1-2.76-2.865H41.97Zm-3.555-2.94A2.563,2.563,0,0,1,41.07-4.23H35.7A2.651,2.651,0,0,1,38.415-6.915Zm11.58-4.035v4.785a3.31,3.31,0,0,0-2.88-1.485,3.63,3.63,0,0,0-3.6,3.945A3.551,3.551,0,0,0,47.115.15a3.34,3.34,0,0,0,2.88-1.515L50.145,0h.72V-10.95ZM47.19-.6c-1.62,0-2.775-1.14-2.775-3.1,0-1.935,1.125-3.165,2.775-3.18,1.545-.015,2.775,1.23,2.775,3.18A2.8,2.8,0,0,1,47.19-.6Zm8.67-3.135A3.627,3.627,0,0,0,59.61.15a3.627,3.627,0,0,0,3.75-3.885A3.636,3.636,0,0,0,59.61-7.65,3.636,3.636,0,0,0,55.86-3.735Zm.9-.015A2.829,2.829,0,0,1,59.61-6.9a2.829,2.829,0,0,1,2.85,3.15A2.824,2.824,0,0,1,59.61-.615,2.824,2.824,0,0,1,56.76-3.75Zm11.985-3.9a2.663,2.663,0,0,0-2.55,1.41L66.06-7.5h-.705V0h.855V-4.11c0-1.575.825-2.715,2.4-2.715,1.3,0,2.22.8,2.22,2.49V0h.87V-4.5A2.836,2.836,0,0,0,68.745-7.65Z" transform="translate(379 58)" fill="#242f46" />
										<g id="shield" transform="translate(-299 -207)">
											<path id="computer-security-shield" d="M47.823,3.281A12.263,12.263,0,0,1,38.872,0a12.261,12.261,0,0,1-8.951,3.281c0,5.878-1.259,14.3,8.951,17.719C49.082,17.58,47.823,9.159,47.823,3.281Z" transform="translate(699.128 270)" fill="#3672ff" />
											<path id="checked_3_" data-name="checked (3)" d="M0,68.241l3.082,3.2L9,65.312l-.85-.869-5.068,5.25L.838,67.366Z" transform="translate(734 212.557)" fill="#fff" />
										</g>
										<path id="Path_1460" data-name="Path 1460" d="M11.7-12.96v4.05H10.548l-.576-2.7H7.236V-1.476l1.908.432V0H2.988V-1.044L4.9-1.476V-11.61H2.142l-.558,2.7H.432v-4.05Zm2.718,8.352a5.02,5.02,0,0,0,.36,2.034A2.014,2.014,0,0,0,16.758-1.3a3.8,3.8,0,0,0,1.584-.351,3.445,3.445,0,0,0,1.332-1.089l.972.756a5.337,5.337,0,0,1-1.7,1.53,5.122,5.122,0,0,1-2.637.63,4.58,4.58,0,0,1-2.277-.531,3.509,3.509,0,0,1-1.449-1.557,4.869,4.869,0,0,1-.4-1.233,8.112,8.112,0,0,1-.126-1.485,5.909,5.909,0,0,1,1.152-3.9A4.054,4.054,0,0,1,16.506-9.9a4.991,4.991,0,0,1,1.764.3,3.708,3.708,0,0,1,1.341.846,3.7,3.7,0,0,1,.846,1.35,5.176,5.176,0,0,1,.3,1.809q0,.2-.009.387t-.045.6Zm2.052-4.05q-1.854,0-2.034,2.9H18.4v-.468a2.82,2.82,0,0,0-.5-1.8A1.717,1.717,0,0,0,16.47-8.658ZM26.784-9.9a5.62,5.62,0,0,1,1.53.2,3.851,3.851,0,0,1,1.215.567,2.7,2.7,0,0,1,.8.891,2.345,2.345,0,0,1,.288,1.152,1.65,1.65,0,0,1-.432,1.233,1.459,1.459,0,0,1-1.062.423,1.326,1.326,0,0,1-.594-.117,1.153,1.153,0,0,1-.387-.306,1.134,1.134,0,0,1-.216-.423,1.793,1.793,0,0,1-.063-.468,1.323,1.323,0,0,1,.225-.774,1.253,1.253,0,0,1,.675-.468,1.731,1.731,0,0,0-.756-.522,3.08,3.08,0,0,0-1.134-.2,2.461,2.461,0,0,0-1.017.2,1.806,1.806,0,0,0-.747.639,3.306,3.306,0,0,0-.468,1.17,8.409,8.409,0,0,0-.162,1.791,7.279,7.279,0,0,0,.126,1.53,4.007,4.007,0,0,0,.342.972,2.275,2.275,0,0,0,.738.819,2.053,2.053,0,0,0,1.152.3,3.532,3.532,0,0,0,.765-.09,4.221,4.221,0,0,0,.792-.261,3.585,3.585,0,0,0,.738-.441,3.04,3.04,0,0,0,.621-.648l.972.756A4.9,4.9,0,0,1,28.773-.315,5.732,5.732,0,0,1,26.406.18a4.594,4.594,0,0,1-2.268-.513,3.593,3.593,0,0,1-1.44-1.5,5.36,5.36,0,0,1-.477-1.323A7.211,7.211,0,0,1,22.05-4.77a6.494,6.494,0,0,1,.324-2.115,4.674,4.674,0,0,1,.927-1.62A3.971,3.971,0,0,1,24.786-9.54,5.248,5.248,0,0,1,26.784-9.9ZM39.168-4.824q0-.576-.018-1T39.1-6.561a2.774,2.774,0,0,0-.09-.531,3.017,3.017,0,0,0-.135-.378A1.625,1.625,0,0,0,37.3-8.352a2.024,2.024,0,0,0-.972.252,1.851,1.851,0,0,0-.738.72,2.771,2.771,0,0,0-.252.666,4.136,4.136,0,0,0-.108,1.026V-1.35l1.206.342V0H31.554V-1.008L32.94-1.35V-12.69l-1.386-.342V-14.04h3.672v6.012A3.73,3.73,0,0,1,36.459-9.4a3,3,0,0,1,1.683-.5,3.921,3.921,0,0,1,1.305.189,2.365,2.365,0,0,1,.927.6,3.467,3.467,0,0,1,.819,1.539,9.876,9.876,0,0,1,.261,2.511V-1.35l1.386.342V0H37.962V-1.008l1.206-.342ZM11.232,10.154a2.753,2.753,0,0,1-.684,1.827,2.82,2.82,0,0,1-.765.612,2.758,2.758,0,0,1-.963.315v.072a4.064,4.064,0,0,1,2.214,1.2,3.156,3.156,0,0,1,.81,2.2,3.451,3.451,0,0,1-.531,1.872,3.408,3.408,0,0,1-1.341,1.26,3.486,3.486,0,0,1-.549.216,5.263,5.263,0,0,1-.693.153,8.761,8.761,0,0,1-.9.09Q7.326,20,6.66,20H.738V18.956l1.512-.378V8.462L.738,8.084V7.04H7.326a4.228,4.228,0,0,1,2.916.918,3.1,3.1,0,0,1,.729,1.008A2.849,2.849,0,0,1,11.232,10.154ZM4.59,13.9V18.65H6.03a7.884,7.884,0,0,0,1.332-.09,2.594,2.594,0,0,0,.846-.288,1.923,1.923,0,0,0,.792-.8A2.563,2.563,0,0,0,9.306,16.2a2.206,2.206,0,0,0-.234-1.062,2.33,2.33,0,0,0-.594-.72,2.306,2.306,0,0,0-.828-.387,5.137,5.137,0,0,0-1.3-.135Zm0-1.314H6.3a2.44,2.44,0,0,0,1.854-.63,2.289,2.289,0,0,0,.468-.639,2.1,2.1,0,0,0,0-1.782,2.289,2.289,0,0,0-.468-.639,2.454,2.454,0,0,0-1.782-.54H4.59Zm11,2.808a5.02,5.02,0,0,0,.36,2.034,2.014,2.014,0,0,0,1.98,1.278,3.8,3.8,0,0,0,1.584-.351,3.445,3.445,0,0,0,1.332-1.089l.972.756a5.337,5.337,0,0,1-1.7,1.53,5.122,5.122,0,0,1-2.637.63,4.58,4.58,0,0,1-2.277-.531,3.509,3.509,0,0,1-1.449-1.557,4.869,4.869,0,0,1-.4-1.233,8.112,8.112,0,0,1-.126-1.485,5.909,5.909,0,0,1,1.152-3.9A4.054,4.054,0,0,1,17.676,10.1a4.991,4.991,0,0,1,1.764.3,3.576,3.576,0,0,1,2.187,2.2,5.176,5.176,0,0,1,.3,1.809q0,.2-.009.387t-.045.6Zm2.052-4.05q-1.854,0-2.034,2.9h3.96v-.468a2.82,2.82,0,0,0-.5-1.8A1.717,1.717,0,0,0,17.64,11.342Zm12.87,3.834q0-.576-.018-1t-.045-.738a2.773,2.773,0,0,0-.09-.531,3.017,3.017,0,0,0-.135-.378,1.625,1.625,0,0,0-1.584-.882,2.024,2.024,0,0,0-.972.252,1.851,1.851,0,0,0-.738.72,2.771,2.771,0,0,0-.252.666,4.136,4.136,0,0,0-.108,1.026V18.65l1.206.342V20H22.9V18.992l1.386-.342V7.31L22.9,6.968V5.96h3.672v6.012A3.73,3.73,0,0,1,27.8,10.6a3,3,0,0,1,1.683-.5,3.921,3.921,0,0,1,1.305.189,2.365,2.365,0,0,1,.927.6,3.467,3.467,0,0,1,.819,1.539,9.876,9.876,0,0,1,.261,2.511V18.65l1.386.342V20H29.3V18.992l1.206-.342Zm6.93.216a5.02,5.02,0,0,0,.36,2.034A2.014,2.014,0,0,0,39.78,18.7a3.8,3.8,0,0,0,1.584-.351A3.445,3.445,0,0,0,42.7,17.264l.972.756a5.337,5.337,0,0,1-1.7,1.53,5.122,5.122,0,0,1-2.637.63,4.58,4.58,0,0,1-2.277-.531A3.509,3.509,0,0,1,35.6,18.092a4.869,4.869,0,0,1-.4-1.233,8.111,8.111,0,0,1-.126-1.485,5.909,5.909,0,0,1,1.152-3.9A4.054,4.054,0,0,1,39.528,10.1a4.991,4.991,0,0,1,1.764.3,3.576,3.576,0,0,1,2.187,2.2,5.176,5.176,0,0,1,.3,1.809q0,.2-.009.387t-.045.6Zm2.052-4.05q-1.854,0-2.034,2.9h3.96v-.468a2.82,2.82,0,0,0-.5-1.8A1.717,1.717,0,0,0,39.492,11.342Zm6.858.288-1.386-.342V10.28H48.1l.4,1.8h.072a3.945,3.945,0,0,1,1.4-1.449,3.525,3.525,0,0,1,1.863-.531,2.962,2.962,0,0,1,1.323.279,2.041,2.041,0,0,1,.837.693,3.951,3.951,0,0,1,.468,1.188,4.3,4.3,0,0,1,1.494-1.593,3.67,3.67,0,0,1,1.962-.567,2.935,2.935,0,0,1,1.3.279,2.085,2.085,0,0,1,.882.765,2.409,2.409,0,0,1,.27.612,5.937,5.937,0,0,1,.18.891q.072.531.1,1.251t.027,1.692v3.06l1.386.342V20H57.168V18.992l1.206-.342V15.176q0-.576-.018-1t-.054-.738a4.2,4.2,0,0,0-.09-.531,2.321,2.321,0,0,0-.126-.378,1.189,1.189,0,0,0-.477-.6,1.227,1.227,0,0,0-.621-.171,2.5,2.5,0,0,0-.828.126,2.1,2.1,0,0,0-.7.432,2.232,2.232,0,0,0-.585.837,3.9,3.9,0,0,0-.225,1.233V18.65l1.206.342V20h-4.7V18.992l1.206-.342V15.176q0-.576-.018-1t-.054-.738a4.2,4.2,0,0,0-.09-.531,2.321,2.321,0,0,0-.126-.378,1.189,1.189,0,0,0-.477-.6,1.227,1.227,0,0,0-.621-.171,2.5,2.5,0,0,0-.828.126,2.1,2.1,0,0,0-.7.432,2.232,2.232,0,0,0-.585.837,3.9,3.9,0,0,0-.225,1.233V18.65l1.206.342V20H44.964V18.992l1.386-.342Zm25.992,3.51a6.928,6.928,0,0,1-.333,2.169,4.568,4.568,0,0,1-.963,1.7,3.352,3.352,0,0,1-1.422.9,7.264,7.264,0,0,1-3.924,0,3.352,3.352,0,0,1-1.422-.9,4.568,4.568,0,0,1-.963-1.7,7.23,7.23,0,0,1,0-4.338,4.568,4.568,0,0,1,.963-1.7,3.352,3.352,0,0,1,1.422-.9,7.264,7.264,0,0,1,3.924,0,3.352,3.352,0,0,1,1.422.9,4.568,4.568,0,0,1,.963,1.7A6.928,6.928,0,0,1,72.342,15.14Zm-6.318,3.114a2.223,2.223,0,0,0,3.276,0,6.055,6.055,0,0,0,.576-3.114,6.055,6.055,0,0,0-.576-3.114,2.223,2.223,0,0,0-3.276,0,6.055,6.055,0,0,0-.576,3.114A6.055,6.055,0,0,0,66.024,18.254ZM73.1,10.532l1.764-.252.216-2.232L77.13,7.76v2.52h2.3v1.17h-2.3v5.886q0,.612.018.837a1.383,1.383,0,0,0,.072.369.342.342,0,0,0,.2.162,1.454,1.454,0,0,0,.468.054h1.26v.792a17.258,17.258,0,0,1-1.845.477,7.17,7.17,0,0,1-1.269.153.987.987,0,0,1-1.044-.666,1.828,1.828,0,0,1-.117-.549q-.027-.333-.027-1.017v-6.5H73.1Zm14.436,4.644q0-.576-.018-1t-.045-.738a2.773,2.773,0,0,0-.09-.531,3.017,3.017,0,0,0-.135-.378,1.625,1.625,0,0,0-1.584-.882,2.024,2.024,0,0,0-.972.252,1.851,1.851,0,0,0-.738.72,2.771,2.771,0,0,0-.252.666,4.136,4.136,0,0,0-.108,1.026V18.65l1.206.342V20H79.92V18.992l1.386-.342V7.31L79.92,6.968V5.96h3.672v6.012A3.73,3.73,0,0,1,84.825,10.6a3,3,0,0,1,1.683-.5,3.921,3.921,0,0,1,1.305.189,2.365,2.365,0,0,1,.927.6,3.467,3.467,0,0,1,.819,1.539,9.876,9.876,0,0,1,.261,2.511V18.65l1.386.342V20H86.328V18.992l1.206-.342ZM95.8,19.082a3.811,3.811,0,0,0,.846-.09,2.686,2.686,0,0,0,.693-.252,1.349,1.349,0,0,0,.468-.405.931.931,0,0,0,.171-.549.954.954,0,0,0-.225-.63,1.977,1.977,0,0,0-.594-.468,5.285,5.285,0,0,0-.828-.351q-.459-.153-.909-.3a7.921,7.921,0,0,1-1.089-.405,3.928,3.928,0,0,1-.954-.612,2.822,2.822,0,0,1-.675-.873,2.627,2.627,0,0,1-.252-1.188,2.575,2.575,0,0,1,.936-2.079,4.073,4.073,0,0,1,2.682-.783,5.728,5.728,0,0,1,1.494.18,3.525,3.525,0,0,1,1.134.513,2.467,2.467,0,0,1,.729.792,1.987,1.987,0,0,1,.261,1,1.272,1.272,0,0,1-.333.954,1.248,1.248,0,0,1-.909.324,1.335,1.335,0,0,1-.9-.279.843.843,0,0,1-.324-.657,1.063,1.063,0,0,1,.18-.585,1.175,1.175,0,0,1,.468-.423,1.659,1.659,0,0,0-.675-.531,2.583,2.583,0,0,0-1.053-.189,1.914,1.914,0,0,0-1.26.351,1.216,1.216,0,0,0-.414.981,1.252,1.252,0,0,0,.468,1.071,3.978,3.978,0,0,0,1.26.585q.72.216,1.422.45a5.865,5.865,0,0,1,1.251.576,2.878,2.878,0,0,1,.882.837,2.094,2.094,0,0,1,.333,1.2,2.364,2.364,0,0,1-.333,1.251,2.8,2.8,0,0,1-.918.918,4.7,4.7,0,0,1-1.377.567,7.036,7.036,0,0,1-1.71.2,4.891,4.891,0,0,1-2.691-.63,1.949,1.949,0,0,1-.963-1.71,1.557,1.557,0,0,1,.414-1.152,1.351,1.351,0,0,1,.99-.414,1.428,1.428,0,0,1,.8.243.781.781,0,0,1,.369.693,1.146,1.146,0,0,1-.2.63,1.34,1.34,0,0,1-.45.45,1.759,1.759,0,0,0,.594.54A2.3,2.3,0,0,0,95.8,19.082Z" transform="translate(379 81)" fill="#242f46" />
										<path id="TB-logo" d="M38.39,23.719H31.544V15.161H48.66C48.66,16.852,44.309,23.719,38.39,23.719ZM0,2.934V0L9.975.02V.01L36.768,0C44.253,0,48.66,5.94,48.66,8.558H7.091C7.091,5.8,5.148,2.934,0,2.934ZM7.091,15.161H23.963v8.558H7.091ZM23.963,38.879H7.091V30.321H23.963Zm7.58-8.558h7.58c7.683,0,11.493,6.152,11.493,8.558H31.544ZM7.091,45.482H23.963v3.668h7.58V45.482l19.073.006c0,3.019-5.489,8.553-11.248,8.553H0V51.106C5.107,51.106,7.091,48.406,7.091,45.482Z" transform="translate(315 47)" fill="#3672ff" fill-rule="evenodd" />
									</g>
								</g>
							</svg>
						</div>

					</a>
				</div>
			</div>
			<Modal ref={subscribeModalRef} modalType="subscribe">
				<SubscribeModal modalRef={subscribeModalRef} />
			</Modal>
			<Modal ref={cookieModalRef} modalType="cookie">
				<CookieModal modalRef={cookieModalRef} />
			</Modal>
		</footer>
	)
}

Footer.propTypes = {
	footer: PropTypes.shape({
		columns: PropTypes.arrayOf(
			PropTypes.shape({
				id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
					.isRequired,
				title: PropTypes.string.isRequired,
				links: PropTypes.arrayOf(linkPropTypes),
			})
		),
		smallText: PropTypes.string.isRequired,
	}),
}

export default Footer
